import { BASE_URL } from './transport';
import { APP_TYPE } from './ui';

export const BASE_IMG_URL = `${BASE_URL}/icons-elon`;

export const IMAGE_SETTINGS = {
  recoveryPassword: {
    info: `${BASE_IMG_URL}/ui-kit/recoveryPassword/phone/${APP_TYPE}.png`,
    phone: `${BASE_IMG_URL}/ui-kit/recoveryPassword/phone/${APP_TYPE}.png`,
    email: `${BASE_IMG_URL}/ui-kit/recoveryPassword/email/${APP_TYPE}.png`,
  },
  errorPage: [
    `${BASE_IMG_URL}/ui-kit/errorPage/top-tape.png`,
    `${BASE_IMG_URL}/ui-kit/errorPage/bottom-tape.png`,
    `${BASE_IMG_URL}/ui-kit/errorPage/top-tape-desk.png`,
    `${BASE_IMG_URL}/ui-kit/errorPage/bottom-tape-desk.png`,
  ],
};
